import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";

export const createRadioGroupStyles = ({
  spacing,
  palette,
  typography,
}: Theme) => {
  return {
    root: css({
      display: "flex",
      flexDirection: "column",
      position: "relative",
      marginBottom: spacing(2),
    }),
    label: css({
      fontSize: typography.fontSize.small,
      color: palette.secondary.text,
      padding: spacing([0, 0, 1, 1]),
    }),
  };
};
